import { useEffect, useMemo, useRef, useState } from "react";

import { Box, Button, Card, Checkbox, Chip, Collapse, Fade, Grid, IconButton, Stack, TextField, Typography } from "@mui/material";

import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { LAYOUT_MARGIN } from "Configs/home";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useWindowSize from "Hooks/useWindowSize";
import { selectPath } from "Redux/trafficPathSlice";
import { createTrafficAnalysisStarUrl } from "Redux/starSlice";

// Doesn't look good but it works :(
const SIZES: { [key: string]: number } = {
  operationBoxHeight: 56,
  marginTop: 16,
  toolsBoxHeight: 56,
  marginBottom: 8,
  topContent: 70,
  bottomContentMargin: 16,
  bottomButtun: 36,
  bottomButtunMargin: 16,
};

export default function Stations() {
  const dispatch = useAppDispatch();
  const { visible, selectedPath } = useAppSelector((state) => state.trafficPath);

  const { height } = useWindowSize();

  const [isOpen, setIsOpen] = useState<boolean>(true);

  const toggleCollapse = () => setIsOpen((prev) => !prev);

  const sideRef = useRef<HTMLDivElement>(null);

  const boxHeight = useMemo(() => {
    let result = 0;
    Object.keys(SIZES).forEach((key) => {
      result += SIZES[key];
    });
    return `${height - (result + LAYOUT_MARGIN * 2)}px`;
  }, [height]);

  const handleBack = () => {
    dispatch(selectPath([]));
    dispatch(
      createTrafficAnalysisStarUrl([
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=dc973766-0757-4b60-ab4d-7053356c6f6b&paramvalues={"72cff555-e8d6-0ff6-7074-531cc33b653c":[{"Value":{"Id":null,"Value":"2018-03-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"2c9d0a67-208d-fe78-4367-1ee6483558df":[{"Value":{"Id":null,"Value":"2018-03-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"126845f7-2786-c8cf-d0b5-09e245516101":[{"Value":[],"FromColumn":false,"SelectedField":null}]}`,
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=8837ad69-c649-4625-921e-1c08cde58fa3&paramvalues={"72cff555-e8d6-0ff6-7074-531cc33b653c":[{"Value":{"Id":null,"Value":"2018-03-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"2c9d0a67-208d-fe78-4367-1ee6483558df":[{"Value":{"Id":null,"Value":"2018-03-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"126845f7-2786-c8cf-d0b5-09e245516101":[{"Value":[],"FromColumn":false,"SelectedField":null}]}`,
      ])
    );
  };
  const renderAllStations = useMemo(() => {
    if (selectedPath.length === 0) return;
    const { stations } = selectedPath[0];
    return (
      <>
        {stations?.map((station: any) => {
          return (
            <Stack direction="row">
              <Box
                sx={{
                  border: "1px solid #aaa",
                  p: 1,
                  borderRadius: 1,
                  width: "98%",
                  marginBottom: "15px",
                  justifyContent: "flex-start",
                }}
              >
                <Stack sx={{ width: "100%" }}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    {station.title}
                  </Grid>
                </Stack>
              </Box>
            </Stack>
          );
        })}
      </>
    );
  }, [selectedPath]);

  return (
    <Fade in={visible && selectedPath.length > 0} mountOnEnter unmountOnExit>
      <Card sx={{ mt: 1, p: 2, width: "100%", boxShadow: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography fontWeight="800">لیست مسیر ها </Typography>
          <Button
            startIcon={<KeyboardDoubleArrowDownIcon sx={{ transform: isOpen ? "rotate(180deg)" : "", transition: "all 0.3s" }} />}
            sx={{ minWidth: "100px" }}
            onClick={toggleCollapse}
          >
            {isOpen ? "بستن" : "بازکردن"}
          </Button>
        </Stack>

        <Collapse in={isOpen}>
          <Box sx={{ height: boxHeight, overflowY: "scroll", mt: 1 }} ref={sideRef}>
            {renderAllStations}
          </Box>
        </Collapse>
        <Collapse in={isOpen}>
          <Stack sx={{ mt: 2, flexDirection: "row-reverse" }}>
            <Button type="button" variant="contained" sx={{ width: "20%" }} onClick={handleBack}>
              <ArrowBackIcon />
            </Button>
          </Stack>
        </Collapse>
      </Card>
    </Fade>
  );
}
